import { authService } from '../../services/auth';
import { onLocaleChange } from '../../services/i18n';
import './rc-auth-status-view';
import { RcAuthStatusView } from './rc-auth-status-view';

export class RcAuthStatus extends HTMLElement {
  private disposeLocaleChange?: () => void;

  connectedCallback(): void {
    this.addEventListener('auth-status-logout', () => authService.logout());
    this.render();
    authService.onAuthChange(() => this.render());
    this.disposeLocaleChange = onLocaleChange(() => this.render());
  }

  disconnectedCallback(): void {
    this.disposeLocaleChange?.();
  }

  private render(): void {
    this.innerHTML = '<rc-auth-status-view></rc-auth-status-view>';
    const view = this.querySelector('rc-auth-status-view') as RcAuthStatusView | null;
    if (!view) return;
    view.isAuthenticated = authService.isAuthenticated;
    view.userName = authService.currentUser?.name || '';
    view.showDashboardLink = this.closest('.landing-header') !== null;
    view.render();
  }
}

if (!customElements.get('rc-auth-status')) {
  customElements.define('rc-auth-status', RcAuthStatus);
}
